import { useAPI } from '@shared/lib/composables';
import type { HttpStatusCode } from '~/shared/types';

export interface BuyFormRequest {
  // Заголовок формы
  title?: string;
  // Специальность клиента
  specialization: string;
  // Название компании
  company?: string;
  // Регион клиента
  region: string;
  // ФИО клиента
  fullName: string;
  // Номер телефона клиента
  phone: string;
  // Email адрес клиента
  email: string;
}

export interface BuyFormResponse {
  success: boolean;
  message?: string;
  status: HttpStatusCode;
  errors?: unknown;
}

/**
 * Обращение с целью покупки КонсультантПлюс
 * @param requestBody BuyFormRequest
 * @returns Promise<BuyFormResponse>
 */
export function sendBuyForm(requestBody: BuyFormRequest): Promise<BuyFormResponse> {
  const config = useRuntimeConfig();
  const route = useRoute();

  const apiUrl = `${config.public.apiUrl}/v1/forms/kpus/buy`;

  const body = {
    form_id: 'b3f03987-a967-45b3-8b02-fdee5a9d51d2',
    form_url: config.public.siteUrl + route.fullPath,
    ...requestBody };

  return useAPI<BuyFormResponse>(apiUrl, { method: 'POST', body });
};
